import { useState, useContext } from "react";
import { makeStyles } from "@mui/styles";
import { HiMenuAlt4, HiX } from "react-icons/hi";
import { FiMoon } from "react-icons/fi";
import { BsSun } from "react-icons/bs";
import { motion } from "framer-motion";
import { IconButton, Hidden } from "@mui/material";

import { uiContext } from "../../../context/Providers/UiProvider";

import "./Navbar.scss";

const useStyles = makeStyles(() => ({
  app__navbar: {
    width: "100%",
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    padding: "1rem 2rem",
    background: ({ darkmode }) =>
      !darkmode ? "rgb(10 15 30 / 15%)" : "rgba(255, 255, 255, 0.25)",
    backdropFilter: "blur(4px)",
    borderBottom: "1px solid rgba(255, 255, 255, 0.25)",
    position: "fixed",
    zIndex: 2,
  },
}));

export const Navbar = () => {
  const [menu] = useState([
    {
      title: "Inicio",
      value: "home",
    },
    {
      title: "Servicios",
      value: "about",
    },
    {
      title: "Portafolio",
      value: "work",
    },
    {
      title: "Habilidades y Experiencias",
      value: "skills",
    },
    {
      title: "Contactame",
      value: "contact",
    },
  ]);
  const [toggle, setToggle] = useState(false);

  const { darkmode, handleChangeTheme } = useContext(uiContext);

  const classes = useStyles({ darkmode });

  return (
    <>
      <nav className={classes.app__navbar}>
        <div className="app__navbar-logo">
          <p>
            EMA<span>DEV</span>
          </p>
        </div>

        {/* <ul className="app__navbar-links">
          {menu.map((item, index) => (
            <li key={index} className="app__flex p-text">
              <div />
              <a href={`#${item}`}>{item}</a>
            </li>
          ))}
        </ul> */}

        <Hidden only={["xs", "sm"]}>
          <IconButton size="small" onClick={handleChangeTheme}>
            {darkmode ? <FiMoon /> : <BsSun style={{ color: "white" }} />}
          </IconButton>
        </Hidden>

        <div className="app__navbar-menu">
          <HiMenuAlt4 onClick={() => setToggle((c) => !c)} />

          {toggle && (
            <motion.div
              animate={toggle ? "open" : "close"}
              whileInView={{ x: [300, 0] }}
              transition={{ duration: 0.85, ease: "easeOut" }}
              exit={{ opacity: 0 }}
            >
              <HiX onClick={() => setToggle((c) => !c)} />
              <ul>
                {menu.map((item, index) => (
                  <li key={index} onClick={() => setToggle((c) => !c)}>
                    <a href={`#${item.value}`}>{item.title}</a>
                  </li>
                ))}
              </ul>
            </motion.div>
          )}
        </div>
      </nav>
    </>
  );
};
